import { Injectable } from '@angular/core';
import { IDBPDatabase, IDBPTransaction } from 'idb';
import * as idb from 'idb';

@Injectable({
  providedIn: 'root'
})
export class IdbService {
  private readonly dbName = 'mldickes-db';
  private readonly dbVersion = 2;
  private idb: IDBPDatabase;

  constructor() {
    if (!('indexedDB' in window)) {
      throw new Error('This browser does not support IndexedDB');
    }
  }

  async idbContext(): Promise<IDBPDatabase> {
    if (this.idb) {
      return this.idb;
    }
    return idb
      .openDB(this.dbName, this.dbVersion, {
        upgrade: (
          database: IDBPDatabase,
          oldVersion: number,
          newVersion: number | null,
          transaction: IDBPTransaction
        ): void => {
          if (oldVersion === 0) {
            database.createObjectStore('tasks');
            database.createObjectStore('logs');
            database.createObjectStore('logs-stopped');
            database.createObjectStore('orders');
          }
          if (oldVersion === 1) {
            database.createObjectStore('orders');
          }
        }
      })
      .then(value => (this.idb = value));
  }
}
